import { PluralRules } from './core';
if (typeof Intl.PluralRules === 'undefined' ||
    (!Intl.PluralRules.polyfilled &&
        new Intl.PluralRules('en', { minimumFractionDigits: 2 }).select(1) ===
            'one')) {
    Object.defineProperty(Intl, 'PluralRules', {
        value: PluralRules,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}
//# sourceMappingURL=polyfill.js.map